<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "WebTabCreated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            const tabPlacement = this.$_.get(this.activity, "payload.tabPlacement");
            const placementText = tabPlacement === "menu" ? "menüye" : tabPlacement === "toolbar" ? "araç çubuğuna" : "";
            return this.$t('notification.webTabCreated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                tabName: this.$_.get(this.activity, 'payload.tabName'),
                placement: placementText
            });
        }
    }
};
</script>


